/* @flow */

export const postBraindateAgreeValue = 'yes';
export const postBraindateDisagreeValue = 'no';
export const postBraindatePostponeValue = 'reschedule';
